// Single-flight gate for auth credential recovery (JWT and API key).
// When one request in a parallel batch hits expiry, every other request
// waits here for that one refresh to finish, then continues with the
// fresh credentials instead of each minting/probing independently.

let refreshPromise = null;

export const isAuthRefreshInFlight = () => Boolean(refreshPromise);

export const waitForAuthRefresh = () => refreshPromise || Promise.resolve(null);

export const runExclusiveAuthRefresh = (refreshFn) => {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = Promise.resolve()
    .then(refreshFn)
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};

export const shouldWaitForAuthRefresh = (config) => {
  if (!config || !isAuthRefreshInFlight()) {
    return false;
  }

  // Never block the refresh probe or a request that is already mid-retry —
  // those are the work the gate itself is waiting on.
  return !(
    config._tokenRefreshProbe ||
    config._authRetry ||
    config._apiKeyRetry ||
    config._skipAuthRefreshWait
  );
};
